import sofaset1 from '../Assets/sofasets1.jpg'

import sofaset3 from '../Assets/sofaset3.jpg'
import sofaset4 from '../Assets/sofaset4.jpg'
import sofaset5 from '../Assets/sofaset5.jpg'

 const data=[
    {
        image:sofaset1,
        name:"Sofa sets",
        description:"Furniture can be a product of design and can be considered a form of decorative art.",
        price:"2000"

    },
    {
        image:sofaset4,
        name:"Living Room",
        description:"Furniture can be a product of design and can be considered a form of decorative art.",
        price:"5330"

    },
    {
        image:sofaset3,
        name:"Dinning Room",
        description:"Furniture can be a product of design and can be considered a form of decorative art.",
        price:"10000"

    },
    {
        image:sofaset4,
        name:"Home office",
        description:"Furniture can be a product of design and can be considered a form of decorative art.",
        price:"20000"

    },
    {
        image:sofaset5,
        name:"Grand Living Set",
        description:"Furniture can be a product of design and can be considered a form of decorative art.",
        price:"60000"

    },
    {
        image:sofaset1,
        name:"Modern Sofa set",
        description:"Furniture can be a product of design and can be considered a form of decorative art.",
        price:"16000"

    },
]
export default data;
